import { render, staticRenderFns } from "./GoCommentsButton.vue?vue&type=template&id=6c0c1b0d"
import script from "./GoCommentsButton.vue?vue&type=script&lang=js"
export * from "./GoCommentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports